import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LogoFull, LogoMark } from "@/components/site/Logo";

const NAV = [
  { to: "/shop", label: "Shop", testId: "nav-shop-link" },
  { to: "/product/complete-construction-job-seeker-pack", label: "The Pack", testId: "nav-pack-link" },
  { to: "/guides", label: "Guides", testId: "nav-guides-link" },
  { to: "/about", label: "About", testId: "nav-about-link" },
  { to: "/faq", label: "FAQ", testId: "nav-faq-link" },
  { to: "/contact", label: "Contact", testId: "nav-contact-link" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-white/10 bg-[#0A0B0D]/85 backdrop-blur-md"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link data-testid="logo-link" to="/" className="flex items-center">
          <span className="hidden sm:inline-flex">
            <LogoFull />
          </span>
          <span className="sm:hidden">
            <LogoMark className="h-10 w-10" />
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testId}
              className={({ isActive }) =>
                `text-sm font-semibold uppercase tracking-widest transition-colors ${
                  isActive ? "text-[#FF5500]" : "text-slate-300 hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          {user && (
            <NavLink
              to="/packs"
              data-testid="nav-mypacks-link"
              className={({ isActive }) =>
                `text-sm font-semibold uppercase tracking-widest transition-colors ${
                  isActive ? "text-[#FF5500]" : "text-slate-300 hover:text-white"
                }`
              }
            >
              My Packs
            </NavLink>
          )}
        </nav>

        <div className="flex items-center gap-4">
          <span className="font-mono-ind hidden text-[10px] uppercase tracking-[0.2em] text-slate-500 sm:block">
            $ AUD
          </span>
          <Link
            data-testid="account-link"
            to="/account"
            className="flex items-center gap-2 border border-white/15 px-3 py-1.5 text-xs font-semibold uppercase tracking-widest text-slate-200 transition-colors hover:border-[#FF5500] hover:text-[#FF5500]"
          >
            <User className="h-3.5 w-3.5" />
            {user ? "Account" : "Sign in"}
          </Link>
          <button
            data-testid="mobile-menu-button"
            className="-mr-2 p-2 text-slate-200 md:hidden"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            aria-expanded={open}
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="mobile-menu" className="border-t border-white/10 bg-[#0A0B0D]/95 px-4 py-4 backdrop-blur-md md:hidden">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`mobile-${item.testId}`}
              onClick={() => setOpen(false)}
              className="block py-3 text-sm font-semibold uppercase tracking-widest text-slate-200"
            >
              {item.label}
            </NavLink>
          ))}
          {user && (
            <NavLink
              to="/packs"
              data-testid="mobile-nav-mypacks-link"
              onClick={() => setOpen(false)}
              className="block py-3 text-sm font-semibold uppercase tracking-widest text-slate-200"
            >
              My Packs
            </NavLink>
          )}
        </nav>
      )}
    </header>
  );
}
